import PropTypes from 'prop-types';
import WhatsAppTemplateSelector from 'src/components/whatsappComponents/WhatsAppTemplateSelector';

/* eslint-disable no-unused-vars */
const WhatsappTemplateModal = ({
    open,
    onClose,
    currentIndex,
    templates,
    onNext,
    onPrevious,
    onSend,
    onSelect,
    loading = false,
    initialStatus = 'ALL',
    providerAccount,
    // Lead of the open conversation. Without it the selector cannot run its
    // audience check at all, so restricted templates render as sendable.
    leadId = null,
}) => {
    // Get the currently selected template based on currentIndex
    const selectedTemplate = templates?.[currentIndex] || null;

    // Handle template selection - update the index
    const handleTemplateSelect = (template) => {
        const newIndex = templates.findIndex(t => t.id === template.id);
        if (newIndex !== -1) {
            onSelect(newIndex);
        }
    };

    // Handle send
    const handleSend = (template) => {
        onSend?.(template);
    };

    return (
        <WhatsAppTemplateSelector
            open={open}
            onClose={onClose}
            templates={templates}
            selectedTemplate={selectedTemplate}
            onSelect={handleTemplateSelect}
            onSend={handleSend}
            loading={loading}
            title="Select WhatsApp Template"
            initialStatus={initialStatus}
            providerAccount={providerAccount}
            leadId={leadId}
        />
    );
};

export default WhatsappTemplateModal;

WhatsappTemplateModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    currentIndex: PropTypes.number.isRequired,
    templates: PropTypes.arrayOf(PropTypes.object).isRequired,
    onNext: PropTypes.func.isRequired,
    onPrevious: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    initialStatus: PropTypes.oneOf(['ALL', 'APPROVED', 'PENDING', 'REJECTED']),
    leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    providerAccount: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        is_connected: PropTypes.bool,
    }),
};

WhatsappTemplateModal.defaultProps = {
    loading: false,
    initialStatus: 'ALL',
    providerAccount: undefined,
};
